// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentInfo } from './paymentInfo';
import {
    PaymentInfoFromJSON,
    PaymentInfoFromJSONTyped,
    PaymentInfoToJSON,
    PaymentInfoToJSONTyped,
} from './paymentInfo';
import type { FeatureLimit } from './featureLimit';
import {
    FeatureLimitFromJSON,
    FeatureLimitFromJSONTyped,
    FeatureLimitToJSON,
    FeatureLimitToJSONTyped,
} from './featureLimit';
import type { Plan } from './plan';
import {
    PlanFromJSON,
    PlanFromJSONTyped,
    PlanToJSON,
    PlanToJSONTyped,
} from './plan';

/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    picture?: string;
    /**
     * 
     * @type {Plan}
     * @memberof UserInfo
     */
    plan?: Plan;
    /**
     * 
     * @type {PaymentInfo}
     * @memberof UserInfo
     */
    paymentInfo?: PaymentInfo;
    /**
     * 
     * @type {number}
     * @memberof UserInfo
     */
    exp?: number;
    /**
     * Feature limits based on user plan. The keys of the map are the feature keys (e.g., "validationTextCharacterLimit").
     * @type {{ [key: string]: FeatureLimit; }}
     * @memberof UserInfo
     */
    limits?: { [key: string]: FeatureLimit; };
}



/**
 * Check if a given object implements the UserInfo interface.
 */
export function instanceOfUserInfo(value: object): value is UserInfo {
    return true;
}

export function UserInfoFromJSON(json: any): UserInfo {
    return UserInfoFromJSONTyped(json, false);
}

export function UserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'email': json['email'] == null ? undefined : json['email'],
        'picture': json['picture'] == null ? undefined : json['picture'],
        'plan': json['plan'] == null ? undefined : PlanFromJSON(json['plan']),
        'paymentInfo': json['paymentInfo'] == null ? undefined : PaymentInfoFromJSON(json['paymentInfo']),
        'exp': json['exp'] == null ? undefined : json['exp'],
        'limits': json['limits'] == null ? undefined : (mapValues(json['limits'], FeatureLimitFromJSON)),
    };
}

export function UserInfoToJSON(json: any): UserInfo {
    return UserInfoToJSONTyped(json, false);
}

export function UserInfoToJSONTyped(value?: UserInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'nickname': value['nickname'],
        'email': value['email'],
        'picture': value['picture'],
        'plan': PlanToJSON(value['plan']),
        'paymentInfo': PaymentInfoToJSON(value['paymentInfo']),
        'exp': value['exp'],
        'limits': value['limits'] == null ? undefined : (mapValues(value['limits'], FeatureLimitToJSON)),
    };
}

